module.exports = __webpack_public_path__ + "img/H5diqiu.4a11cad9.jpg";